import React, { useEffect, useState } from "react";
import styles from "./PasekPostepu.module.css";
import { postepDlaCzasu, useUplywCzasu } from "./czasLadowania";

/** Ile trwa domknięcie paska do 100% i jego zanik po zakończeniu ładowania. */
export const CZAS_DOMKNIECIA_PASKA_MS = 450;

/**
 * [S19 2026-09-14] SMUKŁY PASEK POSTĘPU (3 px) — „process bar ładowania” z polecenia właściciela.
 *
 * Nie znamy prawdziwego postępu zapytania, więc pasek rośnie z CZASU: szybko na początku, potem zwalnia
 * i zatrzymuje się przed 90% ({@link postepDlaCzasu}). Po zakończeniu dopełnia się do 100% i gaśnie.
 * Pasek jest OZDOBĄ (`aria-hidden`) — stan ogłasza rodzic (pigułka globalnego wskaźnika, LadowanieStrony).
 * Nie łapie kliknięć (`pointer-events: none`): informuje, nie blokuje.
 *
 * @param {object} props
 * @param {boolean} props.aktywny czy ładowanie trwa
 * @param {number|null} [props.startedAt] początek (Date.now()); pasek sam tyka
 * @param {number} [props.uplywMs] upływ policzony przez rodzica — bez własnego zegara
 * @param {boolean} [props.przyklejony=false] przyklejony do górnej krawędzi okna (globalny wskaźnik)
 * @param {string} [props.className]
 */
const PasekPostepu = ({ aktywny, startedAt = null, uplywMs, przyklejony = false, className = "" }) => {
    const [faza, setFaza] = useState(aktywny ? "trwa" : "ukryty");

    useEffect(() => {
        if (aktywny) {
            setFaza("trwa");
            return;
        }
        setFaza((poprzednia) => (poprzednia === "trwa" ? "koniec" : poprzednia));
    }, [aktywny]);

    useEffect(() => {
        if (faza !== "koniec") return undefined;
        const minutnik = window.setTimeout(() => setFaza("ukryty"), CZAS_DOMKNIECIA_PASKA_MS);
        return () => window.clearTimeout(minutnik);
    }, [faza]);

    const podany = Number.isFinite(uplywMs);
    const wlasny = useUplywCzasu(podany || !aktywny ? null : startedAt);
    const uplyw = podany ? uplywMs : wlasny;

    if (faza === "ukryty") return null;

    const skala = faza === "koniec" ? 1 : postepDlaCzasu(uplyw);
    const klasy = [
        styles.tor,
        przyklejony ? styles.przyklejony : "",
        faza === "koniec" ? styles.koniec : "",
        className,
    ].filter(Boolean).join(" ");

    return (
        <div className={klasy} aria-hidden="true" data-pasek-postepu={faza}>
            <div className={styles.wypelnienie} style={{ transform: `scaleX(${skala.toFixed(3)})` }} />
        </div>
    );
};

export default PasekPostepu;
